import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export const eventPolicy = [
  {
    id: 'productName',
    value: 'productName',
    text: $t('searchLabel.productName'),
    sortable: true,
    defaultValue: '-',
    width: 310,
    minWidth: 100,
    isVisible: true,
    isDefault: true,
    isFixed: true,
    fixed: 'left'
  },
  {
    id: 'lbName',
    value: 'lbName',
    text: $t('searchLabel.lbName'),
    width: 150,
    sortable: true
  },
  {
    id: 'lbServiceName',
    text: $t('searchLabel.serviceName'), // LB명
    value: 'lbServiceName',
    width: 150,
    sortable: true,
    defaultValue: '-'
  },
  {
    id: 'lbServiceIp',
    text: $t('searchLabel.serviceIp'), // LB서비스 IP
    value: 'lbServiceIp',
    width: 145,
    sortable: true,
    defaultValue: '-'
  },
  {
    id: 'lbSize',
    text: $t('searchLabel.lbSize'), // LB서비스 lbSize
    value: 'lbSize',
    width: 110,
    sortable: true
  },
  {
    id: 'vpcName',
    text: $t('searchLabel.vpcName'),
    value: 'vpcName',
    width: 150,
    sortable: true
  },
  {
    id: 'productIpAddress',
    text: $t('searchLabel.productIpAddress'),
    value: 'productIpAddress',
    width: 120,
    sortable: true
  },
  {
    id: 'metricName',
    text: $t('searchLabel.metricName'),
    value: 'metricName',
    sortable: true,
    isVisible: true
  },
  {
    id: 'objectName',
    text: $t('searchLabel.objectName'),
    value: 'objectName',
    width: 166,
    sortable: true,
    defaultValue: '-',
    isVisible: true
  },
  {
    id: 'metricUnit',
    value: 'metricUnit',
    text: $t('searchLabel.metricUnit'),
    width: 120,
    sortable: true,
    isVisible: true
  },
  {
    id: 'eventLevel',
    text: $t('page.eventStatus.eventLevel'), // 위험도
    value: 'eventLevel',
    width: 125,
    bodyAlign: 'center',
    sortable: true,
    isVisible: true
  },
  {
    id: 'eventThreshold',
    text: $t('page.eventStatus.threshold'), // 임계치
    value: 'eventThreshold',
    width: 270,
    isVisible: true
  },
  {
    id: 'userNames',
    text: $t('page.eventStatus.notifyTo'),
    value: 'userNames',
    width: 166,
    sortable: true,
    isVisible: true
  },
  {
    id: 'disableYn',
    text: $t('page.eventStatus.disableYn'),
    value: 'disableYn',
    width: 128,
    sortable: true,
    isVisible: true
  }
];
